import axios from 'axios';

const store = {
  namespaced: true,
  state: {
    profile: {},
    jwtToken: localStorage.getItem('jwtToken') || null,
    hubConnected: false
  },
  getters: {
    isAuthenticated: state => !!state.jwtToken,
    currentUserId: state => state.profile.userId,
    isDeleted: state => state.profile.isDeleted,
    profile: state => state.profile
  },
  mutations: {
    setProfile(state, profile) {
      state.profile = profile;
    },
    setJwtToken(state, jwtToken) {
      if (jwtToken) {
        localStorage.setItem('jwtToken', jwtToken);
        state.jwtToken = jwtToken;
      } else {
        localStorage.removeItem('jwtToken');
        state.jwtToken = null;
      }
    },
    setHubState(state, value) {
      state.hubConnected = value;
    }
  },
  actions: {
    restoreContext({ commit }) {
      return axios.get('api/account/context')
        .then(res => {
          commit('setProfile', res.data);
        })
        .catch(err => {
          commit('setJwtToken', null);
          throw err;
        });
    },
    login({ commit }, credentials) {
      return axios.post('api/account/login', credentials).then(res => {
        const profile = res.data;
        const jwtToken = res.data.token;
        delete profile.token;
        commit('setProfile', profile);
        commit('setJwtToken', jwtToken);
      });
    },
    changeLastModified({ commit }, date) {
      // eslint-disable-next-line no-underscore-dangle
      const profile_ = this.profile;
      profile_.avatarLastModified = date;
      commit('setProfile', profile_);
    },
    registration(context, credentials) {
      return axios.post('api/account/registration', credentials);
    },
    logout({ commit }) {
      return axios.post('api/Account/Logout').then(() => {
        commit('setProfile', {});
        commit('setJwtToken', null);
      });
    }
  }
};

export default store;
